<template>
  <div class="position-relative">
    <loading-overlay :is-loading="isLoading" />
    <alert
      :dismiss-secs="dismissSecs"
      :show-alert="showAlert"
      :inline="false"
      :is-dismissible="true"
      :variant="variant"
      :message="message"
      @dismissAlert="dismissAlert"
    />
    <component :is="layoutComponent">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingOverlay from '@/app/global/layout/LoadingOverlay.vue';
import Alert from '@/app/global/layout/Alert.vue';
import { getLocale } from '@/utils/i18nHelpers';

export default {
  name: 'App',
  components: {
    LoadingOverlay,
    Alert,
  },
  data() {
    return {
      dismissSecs: 3,
    };
  },
  computed: {
    ...mapState({
      isLoading: state => state.isLoading,
      variant: state => state.variant,
      message: state => state.message,
    }),
    ...mapGetters(['showAlert']),
    pageLanguage() {
      // Return the current locale using the helper, defaulting to 'en_CA'
      const locale = getLocale();
      return locale || 'en_CA';
    },
    layoutComponent() {
      // Dynamically resolve layouts by string name from router.meta.layout
      const layout = this.$route.meta && this.$route.meta.layout;
      if (layout === 'Authenticated') {
        return require('@/app/global/layout/Authenticated.vue').default;
      }
      if (layout === 'NonAuthenticated') {
        return require('@/app/global/layout/NonAuthenticated.vue').default;
      }
      return 'div';
    },
  },
  watch: {
    pageLanguage() {
      this.setMetaData();
    },
  },
  methods: {
    dismissAlert() {
      this.$store.dispatch('resetErrorMessage');
    },
    setMetaData() {
      document.querySelector('meta[name="description"]').content = this.$t('pageDescription');
    },
  },
  created() {
    this.setMetaData();
  },
};
</script>
